module.exports = __webpack_public_path__ + "img/stena23.090300b4.jpg";